import { Form, Formik, FormikConfig } from "formik";
import * as yup from "yup";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import styled from "@emotion/styled";
import React from "react";
import { postSubscription } from "api/newsletter.request";
import { useTranslations } from "next-intl";
import FormWithHostPost from "@components/form-with-host-post";
import FormHotpots from "shared/models/const/form-hotpots";
import SubscriptionForm from "./subscription-form/SubcriptionForm";

function FormFooter() {
  return (
    <CustomForm className="subscribe-blog-hubspot-remaxrd">
      <SubscriptionForm />
      {/* <FormWithHostPost {...FormHotpots.SUSCRIBE_BLOG_FOOTER} /> */}
    </CustomForm>
  );
}

export default FormFooter;

const CustomForm = styled("div")`
  margin-top: 1rem;
  padding: "0px 5px";
  & .subscribe {
    color: white;
    margin: 40px 0;
    padding: 0px 5px;
    color: var(--color-brand-bg-secondary);
    font-size: var(--fs-body-smaller);
    font-weight: 400;
    line-height: 15px;
  }
  & button {
    background-color: #fff;
    color: #1b2e57;
    border: none;
    outline: none;
    margin-top: 10px;
    padding: 9px 20px;
    border-radius: 50px;
    cursor: pointer;
    font-style: normal;
    font-weight: 700;
    font-size: 9px;
    line-height: 10px;
    text-align: center;
    color: var(--color-brand-blue-main);
    max-width: 120px;
    min-width: 120px;
    height: 36px;
    vertical-align: top;
    @media screen and (max-width: 991px) {
      & {
        margin-top: 0;
      }
    }
    @media screen and (max-width: 787px) {
      & {
        align-self: flex-start;
        margin-top: 10px;
      }
    }
  }
`;
